import * as Connector from 'shared/connectors/reportConnector';
import { REPORT } from 'store/types';

const init = () => ({
  type: REPORT.GET_COMPANIES_LABELS_INIT,
});

export const success = data => ({
  type: REPORT.GET_COMPANIES_LABELS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: REPORT.GET_COMPANIES_LABELS_FAILURE,
});

const getCompaniesLabels = () => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getCompaniesLabels();
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getCompaniesLabels;
